import BaseSportPage from '../components/shared/BaseSportPage';
export default function Volleyball() {
  return <BaseSportPage sport="volleyball" label="Volleyball" />;
}
